import {Box, BoxProps, Button, Center, Flex, Heading, Spacer, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {useDesktop, useTranslation} from 'hooks';
import {useRouter} from 'next/router';
import {FC, PropsWithChildren} from 'react';
import LinkUI from 'ui/LinkUI';

interface Props extends BoxProps {
  title: string;
  viewAllLabel?: string;
  count?: string;
  linkTo?: string;
  titleStyle?: BoxProps;
  disableCount?: boolean;
  onHeaderClick?: () => void;
}

export const Section: FC<PropsWithChildren<Props>> = ({
  viewAllLabel,
  title,
  linkTo,
  children,
  count,
  titleStyle,
  disableCount,
  onHeaderClick,
  ...props
}) => {
  const {pathname} = useRouter();
  const isMainPage = pathname === '/';
  const isDesktop = useDesktop();
  const {t} = useTranslation();

  return (
    <Box pb={['20px', '30px']} pt={title ? ['20px', '30px'] : 0} bg="white" {...props} overflow="hidden">
      <Flex
        mb="15px"
        pr={['15px', '30px']}
        h="30px"
        alignItems="center"
        onClick={() => onHeaderClick && onHeaderClick()}
      >
        <Box ml={isMainPage ? ['15px', '30px'] : ['5px', '30px']}>
          <Heading
            as="h1"
            pb={['0px', '20px']}
            fontSize={['20px', '36px']}
            lineHeight={['20px', '44px']}
            {...titleStyle}
          >
            {title}
          </Heading>
        </Box>
        <Spacer />
        {linkTo && (
          <LinkUI href={linkTo}>
            <Center pb={['0px', '30px']} cursor="pointer">
              {count && (
                <>
                  <Text fontSize={['0px', '18px']} fontWeight="600" color={colors.textGray} whiteSpace="nowrap">
                    {viewAllLabel}
                  </Text>
                  {disableCount ? null : (
                    <Button h="30px" px="12px" ml="10px" as="span" bg={colors.lightGray} borderRadius="16px">
                      {isDesktop ? count : t('viewMore')}
                    </Button>
                  )}
                </>
              )}
            </Center>
          </LinkUI>
        )}
      </Flex>
      {children}
    </Box>
  );
};
